import { Grid } from "@mui/material";
import { A_YES_AND_NOT } from "@/src-refactor/modules/shared/model/const/yes-and-not.conts";
import MxFormL3RushRadioDuoField from "@rf-l3/form/MxFormL3RushRadioDuo";
import PrevioMitur from "./PrevioMitur";
import DefinitiveMitur from "./DefinitiveMitur";
import useHasConfotur from "../../hooks/useHasConfotur";
import useHasTrust from "../../hooks/useHasTrust";
import ContentSection from "../../ContentSection";
import { useFormValidationsDocumentsMsgSlice } from "@rf/property/module/components/property-form/store/slices/form-validations-documents-msg/FormValidationsDocumentsMsgSlice";
import useMediaQuery from "@/shared/hooks/use-media-query";
import MxFormL3AutoComplete from "@rf-l3/form/MxForml3AutoComplete";
import { CPropertyValidationDocumentKeys } from "@rf/property/module/components/property-form/util/schemas/validation-documents/validation-document.schema";
function Confotur() {
  const { YES } = useHasConfotur();
  const { isMobile } = useMediaQuery();

  const { HAS_TRUST_NO: NOT } = useHasTrust();
  const {
    validationDocuments: { previous_mitur, final_confotur }
  } = useFormValidationsDocumentsMsgSlice();

  return (
    <Grid container item xs={12}>
      {!isMobile && (
        <Grid item maxWidth={500} minWidth={500} my={2}>
          <MxFormL3RushRadioDuoField
            withreacthookform={1}
            items={A_YES_AND_NOT}
            label="¿Tiene este proyecto CONFOTUR?"
            name={CPropertyValidationDocumentKeys.has_confotur}
          />
        </Grid>
      )}
      {isMobile && (
        <Grid item xs={12} my={2}>
          <MxFormL3AutoComplete
            withreacthookform={1}
            items={A_YES_AND_NOT}
            label="¿Tiene este proyecto CONFOTUR?"
            name={CPropertyValidationDocumentKeys.has_confotur}
          />
        </Grid>
      )}

      {YES && (
        <Grid item xs={12}>
          <ContentSection
            title="Previo MITUR y definitivo CONFOTUR"
            tooltip="Confotur"
            color="blue"
            alert={previous_mitur?.alert || final_confotur?.alert}
          >
            <Grid container item xs={12} spacing={1}>
              {NOT && YES && <PrevioMitur />}
              {YES && <DefinitiveMitur />}
            </Grid>
          </ContentSection>
        </Grid>
      )}
    </Grid>
  );
}

export default Confotur;
